package or.garden.manager.features.catalog.components

import androidx.compose.runtime.Composable
import or.garden.manager.domain.model.CropData
import or.garden.manager.ui.utils.getCropImageSource
import org.jetbrains.compose.web.dom.*

@Composable
fun WebCropCard(crop: CropData, onToggleFavorite: () -> Unit, onClick: () -> Unit) {
    Div({
        classes(
            "bg-white", "rounded-2xl", "p-6", "shadow-sm", "border", "border-gray-100", "hover:shadow-md", "transition-all", "flex", "items-center", "gap-4", "cursor-pointer"
        )
        onClick { onClick() }
    }) {
        Div({
            classes(
                "w-16", "h-16", "bg-emerald-50", "rounded-xl", "flex", "items-center", "justify-center", "flex-shrink-0", "overflow-hidden"
            )
        }) {
            val imageSource = getCropImageSource(crop.icon)
            if (imageSource != null) {
                Img(src = imageSource, attrs = {
                    classes("w-10", "h-10", "object-contain")
                })
            } else {
                I({ classes("fas", "fa-leaf", "text-emerald-600", "text-2xl") })
            }
        }

        Div({ classes("flex-1") }) {
            H3({ classes("font-bold", "text-gray-900") }) { Text(crop.name) }
            P({ classes("text-gray-500", "text-sm", "mt-1") }) {
                Text("Razmak: ${crop.spacingBetweenRows}cm x ${crop.spacingBetweenPlants}cm")
            }
            Div({ classes("flex", "items-center", "gap-2", "mt-2") }) {
                val waterColor = when (crop.waterRequirements?.lowercase()) {
                    "low" -> "text-blue-400"
                    "medium" -> "text-blue-500"
                    else -> "text-blue-700"
                }
                I({ classes("fas", "fa-tint", "text-[10px]", waterColor) })
                Span({ classes("text-xs", "font-semibold", waterColor) }) {
                    Text(
                        when (crop.waterRequirements?.lowercase()) {
                            "low" -> "NISKO"; "medium" -> "SREDNJE"; else -> "VISOKO"
                        }
                    )
                }
            }
        }

        Button({
            classes("w-10", "h-10", "rounded-full", "flex", "items-center", "justify-center", "transition-colors")
            if (crop.isFavourite) {
                classes("text-red-500", "bg-red-50")
            } else {
                classes("text-gray-300", "hover:bg-gray-50")
            }
            onClick {
                it.stopPropagation()
                onToggleFavorite()
            }
        }) {
            I({ classes(if (crop.isFavourite) "fas" else "far", "fa-heart") })
        }
    }
}
